module.exports = {
  ACTIVE: 'active',
  PENDING: 'pending',
  DELETED: 'deleted',
  APPROVED: 'approved',
  REVOKED: 'revoked',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  SUCCESS: 'success',
  FAILURE: 'failure',
  INACTIVE: 'inactive',
};



// WEBPACK FOOTER //
// ./src/constants/Status.js